export default __webpack_public_path__ + "static/media/seven.d128edd7.jpeg";